const lightBg = '#fafafa',
primary = '#360002',
secondary = '#c89624';

export default {
    primary: primary,
    secondary: secondary,
    themes: {
        light: {
            primary: primary,
            secondary: secondary,
            ebadge: '#ed5757',
            accent: '#82B1FF',
            error: '#ea4646', // #FF5252
            info: '#2196F3',
            success: '#13AC46',
            warning: '#FFC107',

            appbg: lightBg,
            navbarbg: '#fff',
            appmenulightbg: '#fff',
            appmenubg: '#280c0d',
            surface: '#ffffff',
            surface2: '#f5f5f5',

            link: '#002580',
            text: '#4e515f',
            muted: '#797979',
            tooltip: '#121212',
            snackbar: '#121212',

            'deep-purple': '#561bbe',
            'strong-text': '#111111',
            'border-color': '#e2e2e2',
        },
    }
}
